<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-banner icon="edit">
        Create Template
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col cols="12">
      <v-form ref="templateCreateForm" @submit.prevent="submit">
        <v-text-field
          v-model="templateName"
          style="padding: 0 16px"
          :rules="nameRules"
          type="text"
          label="Template Name"
          @focus="$event.target.select()"
          outlined
          persistent-hint
          hint="Name to identify Template"
          maxlength="40"
          counter
          color="blue darken-2"
        ></v-text-field>

        <v-card-actions class="mt-4">
          <v-spacer />
          <v-btn :loading="savingForm" outlined color="blue darken-2" type="submit">Create Template</v-btn>
        </v-card-actions>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      savingForm: false,
      templateName: "",
      nameRules: [v => !!v || "Name Required"]
    };
  },
  methods: {
    ...mapActions(["createNewTemplate", "setSnackbar"]),

    async submit() {
      console.log("-- Template Form");
      console.log(this.templateName);
      console.log(this.$refs.templateCreateForm);

      if (this.$refs.templateCreateForm.validate()) {
        this.savingForm = true;

        let orderObject = {
          name: this.templateName
        };

        let response = await this.createNewTemplate(orderObject);
        console.log("-- Template Create Reponse");
        console.log(response);

        if (response) {
          this.setSnackbar({ text: "Created new template" });

          this.templateName = "";
          this.$router.push({
            name: "TemplateOrders"
          });
        } else {
          this.setSnackbar({ color: "error", text: "Error creating template" });
        }

        this.savingForm = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
</style>